import React, { useState } from "react";
import axios from "axios";
import { Button, Modal, Form, Input, message, Checkbox } from "antd";
import { useMutation, useQueryClient } from "react-query";

export default function AddNegozioModal() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  // Get QueryClient from the context
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (negozio) => {
      return axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/negozi`,
        negozio
      );
    },
    {
      onError: (error, variables, context) => {
        message.error(error.message);
      },
      onSuccess: (data, variables, context) => {
        console.log(data);
        setIsModalVisible(false);
        message.success("utenti aggiunto con successo");
        queryClient.invalidateQueries("negozi");
      },
    }
  );

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onFinish = (values) => {
    // console.log('Success:', values);
    mutation.mutate(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div>
      <Button type="primary" onClick={showModal}>
        Aggiungi un nuovo negozio
      </Button>
      <Modal
        title="Basic Modal"
        visible={isModalVisible}
        onCancel={handleCancel}
        onOk={handleOk}
        footer={[]}
      >
        <Form name="basic" onFinish={onFinish} onFinishFailed={onFinishFailed}>
          <Form.Item
            label="Username"
            name="username"
            rules={[{ required: true, message: "Inserire un nome utente" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            name="diretto"
            label="Diretto"
            valuePropName="checked">
            <Checkbox />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: "Inserire una password" }]}
          >
            <Input.Password />
          </Form.Item>


          <Form.Item
            label="Indirizzo"
            name="indirizzo"
            rules={[{ required: true, message: "Inserire l'indirizzo del negozio per favore" }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Latitudine"
            name="latitudine"
            rules={[{ required: false }]}
          >
            <Input type="number" />
          </Form.Item>

          <Form.Item
            label="Longitudine"
            name="longitudine"
            rules={[{ required: false }]}
          >
            <Input placeholder="" type="number" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit">
              Aggiorno
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
